// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import { decodeToken } from 'utils/functions/jwt-token';
import { getJwtToken } from 'utils/functions/session-storage';
import { getMenuAndRoutes } from 'utils/functions/get-menu-and-routes';
// import menuItems from 'menu-items/index';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const token = getJwtToken();
  const userData = decodeToken(token);
  const role = userData?.user_type;
  // const { menuItems } = getMenuAndRoutes(userData?.license);
  const { menuItems } = getMenuAndRoutes('media');

  // const menuItems = role === 'A' ? adminMenuItems.items : retailerMenuItems.items;

  const navGroups = menuItems.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} level={1} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
